export default {
  viewBox: "0 0 24 24",
  html: "<path d=\"M16.59 6 12 10.58 7.41 6 6 7.41l6 6 5.999-5.999v-.002z\"/><path d=\"m12 15.579-4.59-4.58L6 12.409l6 6.001 5.999-5.999v-.002l-1.409-1.41z\"/>"
};